import { render, staticRenderFns } from "./AdvertisingCarousel.vue?vue&type=template&id=13a5b08c&scoped=true&"
import script from "./AdvertisingCarousel.vue?vue&type=script&lang=js&"
export * from "./AdvertisingCarousel.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisingCarousel.vue?vue&type=style&index=0&id=13a5b08c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a5b08c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
